import { ChannelHandler } from "./ChannelHandler";

// a channel for simple message packaging/unpackaging
export class LP5Channel extends ChannelHandler {
  protected _channelName: string;
  public getChannelName() {
    return this._channelName;
  }

  constructor(channelName: string = "LP5_PLAYER_CHANNEL") {
    super();
    this._channelName = channelName;
  }

  handlesChannel(channelName: any): boolean {
    return channelName == this._channelName;
  }

  // packages up a message right before its sent across a currier
  packageMessage(
    channelName,
    rawMessage,
    currier,
    responseKey = null,
    responseTo = null
  ) {
    let obfuscatedMessage = btoa(rawMessage);
    // console.log(
    //   "outgoing rawMessage",
    //   rawMessage,
    //   obfuscatedMessage,
    //   atob(obfuscatedMessage)
    // );
    return {
      channel: channelName,
      message: obfuscatedMessage,
      responseKey,
      responseTo,
    }; // eventually this could be a class but its probably ideal for it to remain as simple as possible
  }

  // this should return an object as with a channel and a message
  unpackMessage(packagedMessage) {
    let message = packagedMessage.message;
    try {
      message = atob(message);
    } catch (e) {
      // console.log("had a problem with atob");
      message = packagedMessage.message;
    }
    return { ...packagedMessage, message };
  }
}
